import useTranslation from 'next-translate/useTranslation'
import { useEffect } from 'react'

import { NAMESPACE_COMMON } from '@/res/namespaces'
import { IFaqDetail } from '@/types/Common'

interface Props {
  faq_info: IFaqDetail[]
  title?: string
}

const FaqSection: React.FC<Props> = ({ faq_info, title }) => {
  const { t } = useTranslation(NAMESPACE_COMMON)

  useEffect(() => {
    //eslint-disable-next-line
    // @ts-ignore
    const use = async () => (await import('tw-elements')).default

    use()
  }, [])

  return (
    <>
      <div className="container mb-20">
        <h2 className="text-primary font-bold  text-2xl desktop:text-[32px] desktop:leading-10 hr:text-6xl tablet:text-[28px] tablet:leading-9 w-full whitespace-pre-line normal-case">
          {title ? title : t('faq_info')}
        </h2>
        {faq_info.map((faq) => (
          <div
            key={faq.id}
            className="accordion accordion-flush"
            id={`#accordionFlushExample${faq.id}`}
          >
            <div className="accordion-item border-t-0 border-l-0 border-r-0 rounded-none bg-white border border-gray-200">
              <h2 className="accordion-header mb-0" id={faq.id.toString()}>
                <button
                  className="font-bold accordion-button relative flex items-center w-full py-4 px-5 text-base text-gray-700 text-left bg-white border-0 rounded-none transition focus:outline-none"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#flush-collapseOne${faq.id}`}
                  aria-expanded="true"
                  aria-controls={`flush-collapseOne${faq.id}`}
                >
                  {faq.question}
                </button>
              </h2>
              <div
                id={`flush-collapseOne${faq.id}`}
                className="accordion-collapse border-0 collapse"
                aria-labelledby={faq.id.toString()}
                data-bs-parent={`accordionFlushExample${faq.id}`}
              >
                <div
                  className="accordion-body py-4 px-5 text-gray-500"
                  dangerouslySetInnerHTML={{ __html: faq.answer }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default FaqSection
